import React from 'react';

import CalculatingLoans from './calculating-loans.svg';
import DifferentAspectsOfLife from './different-aspects-of-life.svg';
import HandHoldingBagOfMoney from './hand-holding-bag-of-money.svg';
import VirusMoneyBag from './virus-money-bag.svg';

type ImageProps = React.ImgHTMLAttributes<HTMLImageElement>;

export const VirusMoneyBagImage = (props: ImageProps) => (
  <img {...props} src={VirusMoneyBag} alt="Money bag with virus beside it" />
);

export const HandHoldingBagOfMoneyImage = (props: ImageProps) => (
  <img {...props} src={HandHoldingBagOfMoney} alt="Hand holding bag of money" />
);

export const DifferentAspectsOfLifeImage = (props: ImageProps) => (
  <img
    {...props}
    src={DifferentAspectsOfLife}
    alt="3 panels showing a house, a graduation cap, and a car"
  />
);

export const CalculatingLoansImage = (props: ImageProps) => (
  <img
    {...props}
    src={CalculatingLoans}
    alt="Pencil writing on some paper, with a percentage logo on the top left"
  />
);
